import { render } from "./Home.vue?vue&type=template&id=4f810a51&scoped=true&ts=true"
import script from "./Home.vue?vue&type=script&lang=ts"
export * from "./Home.vue?vue&type=script&lang=ts"

import "./Home.vue?vue&type=style&index=0&id=4f810a51&lang=less&scoped=true"

import exportComponent from "F:\\luyou\\luyou_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f810a51"]])

export default __exports__